import PropTypes from "prop-types";

import SelectedSchoolTab from "./SelectedSchoolTab";
import SelectedSchoolReasons from "./SelectedSchoolReasons";
import T from "../translations/Translations";

import "../../styles/SelectedSchools.scss";

/**
 * @description School Choice selection, view and disposition page
 * @name SchoolChoice
 * @returns {JSX.Element}
 */
const SelectedSchoolsBlock = ({
    feeders,
    formDispatch,
    formState,
    oeStudentInfo,
    reasons,
    selectedSchoolTab,
    setSelectedSchoolTab
}) => {
    /**
     * @name showSelectedSchoolReasons
     * @return {bool}
     */
    const showSelectedSchoolReasons = () => {
        return (
            reasons &&
            reasons.length > 0 &&
            formState.schoolChoiceDetailDtos.length > 0 &&
            formState.schoolChoiceDetailDtos[selectedSchoolTab]
        );
    };

    return (
        <section className="selected-schools-container">
            <h5 className="dark-blue-text">{T({ key: "OE_Schools_My_Schools_Title" })}</h5>
            <p className="dark-blue-text">{T({ key: "OE_Schools_My_Schools_Body" })}</p>
            <div className="selected-schools-tab-container">
                {formState.schoolChoiceDetailDtos.map((school, index) => {
                    const uniqueKey = `selected-school-tab-${index}`;
                    const tmpClass =
                        selectedSchoolTab === index
                            ? "reasons-tab-card-container card-active"
                            : "reasons-tab-card-container";
                    return (
                        <SelectedSchoolTab
                            className={tmpClass}
                            feeders={feeders}
                            formDispatch={formDispatch}
                            formState={formState}
                            index={index}
                            key={uniqueKey}
                            oeStudentInfo={oeStudentInfo}
                            reasons={reasons}
                            school={school}
                            selectedSchoolTab={selectedSchoolTab}
                            setSelectedSchoolTab={setSelectedSchoolTab}
                        />
                    );
                })}
            </div>
            {showSelectedSchoolReasons() && (
                <SelectedSchoolReasons
                    formDispatch={formDispatch}
                    formState={formState}
                    reasons={reasons}
                    school={formState.schoolChoiceDetailDtos[selectedSchoolTab]}
                />
            )}
        </section>
    );
};

SelectedSchoolsBlock.propTypes = {
    feeders: PropTypes.oneOfType([PropTypes.object]).isRequired,
    formDispatch: PropTypes.func.isRequired,
    formState: PropTypes.oneOfType([PropTypes.object]).isRequired,
    oeStudentInfo: PropTypes.oneOfType([PropTypes.object]).isRequired,
    reasons: PropTypes.instanceOf(Array).isRequired,
    selectedSchoolTab: PropTypes.number,
    setSelectedSchoolTab: PropTypes.func.isRequired
};

SelectedSchoolsBlock.defaultProps = {
    selectedSchoolTab: 0
};

export default SelectedSchoolsBlock;
